// import { MainModule } from './modules/main/main.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER  } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { ObserversModule} from '@angular/cdk/observers';

import { SharedModule } from './shared/shared.module';
// import { OAuthModule } from 'angular-oauth2-oidc';
/* BH Design System */
import { ThemeLibModule, BhHeaderLinks, NavService, BhModalService} from 'bh-theme';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppConfigModule } from './app-config/app-config.module';
import { ApiInterceptor } from './shared/services/api-interceptor';
import { AppConfigService } from './app-config/app-config.service';
import { AuthConfigModule } from './modules/auth/auth.config.module';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { CommonModule } from '@angular/common';
import { MatNativeDateModule} from '@angular/material/core';
import {MatCardModule} from '@angular/material/card';
import {FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { HeaderProfileMenuComponent } from 'src/app/components/header-profile-menu/header-profile-menu.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { DeviceInfoService } from './services/device-info.service';
import { PleFooterComponent } from './components/ple-footer/ple-footer.component';
import { PleModalComponent, PleModalDataService } from './components/ple-modal/ple-modal.component';
import { InsertionDirective } from './components/ple-modal-service/insertion.directive';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { IMqttServiceOptions, MqttModule } from 'ngx-mqtt';
import { HeaderNavigationMenuComponent } from './components/header-notification-menu/header-notification-menu.component';
import { AssetTreeComponent } from './components/assetTree/asset-tree.component';


const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

// Bugfender.init({
//   appKey: '9wPYjWtcMomjwZuqeESi7g9vMLJdLcJo',
//   version: '<version>',
//   build: '<build>',
// });
const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  hostname: '10.124.16.163',
  port: 1883,
  protocol:"wss",
  path: '/mqtt',
};

@NgModule({
  declarations: [
    AppComponent,
    SideNavComponent,
    HeaderProfileMenuComponent,
    PleFooterComponent,
    PleModalComponent,
    InsertionDirective,
    ConfirmDialogComponent,
    HeaderNavigationMenuComponent,
    AssetTreeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    ObserversModule,
    ThemeLibModule,
    BrowserAnimationsModule,
    AppConfigModule,
    AuthConfigModule,
    NgHttpLoaderModule.forRoot(),
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
    CommonModule,
    SharedModule,
    ThemeLibModule,
    MatCardModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule
  ], 
  providers: [{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: {disabled:true} },
    NavService, 
    BhModalService,
    AppConfigService,
    DeviceInfoService,
    PleModalDataService,
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor,multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
